module.exports = __webpack_public_path__ + "img/popup-close.5ac64f5f.svg";